import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 44 44"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M18.292 0h9.393v16.5H44V26H27.685v18h-9.393V26H0v-9.5h18.292zm1.978 2v16.5H1.978V24H20.27v18h5.438V24h16.315v-5.5H25.708V2z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }